import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document2",
  "use": "icon-document2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document2\">\n<path d=\"M13 6H9V2H3V14H13V6ZM12.594 5L10 2.406V5H12.594ZM2.5 1H10L14 5V14.5C14 14.646 13.9532 14.7658 13.8595 14.8595C13.7658 14.9532 13.646 15 13.5 15H2.5C2.354 15 2.23417 14.9532 2.1405 14.8595C2.04683 14.7658 2 14.646 2 14.5V1.5C2 1.354 2.04683 1.23417 2.1405 1.1405C2.23417 1.04683 2.354 1 2.5 1ZM5 8H11V9H5V8ZM5 5H7.5V6H5V5ZM5 11H11V12H5V11Z\" fill=\"#095540\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol